import React from 'react';
import { Play } from 'lucide-react';

const VideoGallery = () => {
  const videos = [
    { id: 'PqD-14NKAKw', title: 'Porto Seguro 3' },
    { id: 'Y8TgGCLheC8', title: 'Porto Seguro 2' },
    { id: 'u0wxTwJ4UN0', title: 'Porto Seguro 1' },
    { id: 'reQWepq06_M', title: 'Pousada Verdes Mares' }
  ];

  return (
    <section className="py-16 bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-full mb-3">
            <Play className="w-4 h-4" />
            <span className="font-semibold text-sm">Vídeos</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            Veja nossas <span className="text-red-500">viagens</span>
          </h2>
          <p className="text-lg text-gray-300">
            Momentos reais dos nossos grupos
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {videos.map((video, index) => (
            <div
              key={index}
              className="relative aspect-[9/16] rounded-2xl overflow-hidden shadow-2xl hover:shadow-red-500/20 transition-all duration-300 hover:-translate-y-2 bg-gray-800"
            >
              <iframe
                src={`https://www.youtube.com/embed/${video.id}`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGallery;
